import { useParams } from 'react-router-dom';
import { useSupplierManagementReadQuery } from 'api';
import { ManagementRoleMapping } from 'models/Manager';
import { useCallback, useMemo, useState } from 'react';

export const useManagement = () => {
  const { id } = useParams() as { id: string };
  const [openEditManagement, setOpenEditManagement] = useState<boolean>(false);
  const { data: managersData = {} } = useSupplierManagementReadQuery({ supplierId: id });
  const { purchaseManager, purchaseManagerAssistant, postSalesManager, postSalesManagerAssistant, salesManagers } =
    managersData;
  const onOpenCloseEditManagement = useCallback(() => {
    setOpenEditManagement((oState) => !oState);
  }, []);

  const managementData = useMemo(() => {
    return [
      { role: ManagementRoleMapping.purchaseManager, data: purchaseManager },
      { role: ManagementRoleMapping.purchaseManagerAssistant, data: purchaseManagerAssistant },
      { role: ManagementRoleMapping.postSalesManager, data: postSalesManager },
      { role: ManagementRoleMapping.postSalesManagerAssistant, data: postSalesManagerAssistant },
    ];
  }, [purchaseManager, purchaseManagerAssistant, postSalesManager, postSalesManagerAssistant]);

  return {
    managementData,
    onOpenCloseEditManagement,
    openEditManagement,
    salesManagers,
    managersData,
  };
};
